import { render, staticRenderFns } from "./BlackjackSeatElement.vue?vue&type=template&id=f7f271fa&scoped=true"
import script from "./BlackjackSeatElement.vue?vue&type=script&lang=js"
export * from "./BlackjackSeatElement.vue?vue&type=script&lang=js"
import style0 from "./BlackjackSeatElement.vue?vue&type=style&index=0&id=f7f271fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f271fa",
  null
  
)

export default component.exports